import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-ted',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>TED icon</title><path d="M0 7.664v2.223h2.43v6.449H5.1v-6.45h2.43V7.665zm7.945 0v8.672h7.31v-2.223h-4.638v-1.08h4.637v-2.066h-4.637v-1.08h4.637V7.664zm7.759 0v8.672h3.863c3.024 0 4.433-1.688 4.433-4.349 0-2.185-1.021-4.323-3.912-4.323zm2.672 2.223h.85c1.931 0 2.102 1.518 2.102 2.063 0 .815-.243 2.163-1.907 2.163h-1.045z"/></svg>`,
    styles: []
})
export class SimpleIconsTedComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#E62B1E';
    @Input() className: string = 'simple-icons-ted'
    constructor() {}
    ngOnInit(): void {}
}
